import React, { useEffect } from "react";
import { useApiClient } from "../../../../shared/customHooks";
import { useApplicationContext } from "../../context/applicationContext";
import { contextOfChildFormLegacy } from "../../../../shared/formObjects/application/legacy/contextOfChildFormLegacy";
import BaseApplicationComponent from "../../../../shared/baseComponent/baseWrappers/BaseApplicationComponent";

export default function ContextOfChildComponentLegacy({ disabled, data }: any) {
  const formApi = useApiClient("ContextOfChildLegacy");
  const { id } = useApplicationContext();
  const { setHeaderText } = useApplicationContext();
  useEffect(() => {
    setHeaderText({
      value: "Assessment of the Context of the Child",
      icon: "view-app-icon icon-spec mr-3 mt-0",
    });
  }, []);
  return (
    <>
      {" "}
      <BaseApplicationComponent
        formBody={contextOfChildFormLegacy}
        headerLabel="Assessment of Context of the Child"
        editPath="contextofchildLegacy"
        apiClient={formApi}
        disabled={disabled}
        data={data}
        id={id}
      />
    </>
  );
}
